import React from 'react'

const BookMarkIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M5.00001 18.3333C4.54168 18.3333 4.14932 18.1701 3.82293 17.8437C3.49654 17.5174 3.33334 17.125 3.33334 16.6667V3.33332C3.33334 2.87499 3.49654 2.48263 3.82293 2.15624C4.14932 1.82985 4.54168 1.66666 5.00001 1.66666H15C15.4583 1.66666 15.8507 1.82985 16.1771 2.15624C16.5035 2.48263 16.6667 2.87499 16.6667 3.33332V16.6667C16.6667 17.125 16.5035 17.5174 16.1771 17.8437C15.8507 18.1701 15.4583 18.3333 15 18.3333H5.00001ZM9.16668 9.16666L11.25 7.91666L13.3333 9.16666V3.33332H9.16668V9.16666Z"
        fill="#FF5612"
      />
    </svg>

  )
}

export default BookMarkIcon